<template>
  <el-dialog :title="title" :visible="visible">
    <el-form label-width="80px" :model="editForm" :rules="rules" ref="editForm">
      <el-form-item label="用户名" prop="email">
        <el-input
          size="small"
          v-model="editForm.email"
          auto-complete="off"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <!-- <el-input
          size="small"
          v-model="editForm.password"
          auto-complete="off"
          placeholder="请输入用户名"
        ></el-input> -->
        <el-input
          placeholder="请输入密码"
          v-model="editForm.password"
          show-password
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="角色" prop="role">
        <!-- <el-input
          size="small"
          v-model="editForm.password"
          auto-complete="off"
          placeholder="请输入用户名"
        ></el-input> -->
        <el-select @change="changeRole" v-model="editForm.role"  placeholder="请选择角色" @click.once.native="getList">
          <el-option
            v-for="item in roleList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="生产日期" prop="date">
        <el-date-picker v-model="editForm.date" type="date" placeholder="选择日期">
        </el-date-picker>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">取消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        class="title"
        @click="submitForm"
        v-if="!showView"
        >保存</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {getProcessList} from "../../../api/process"
export default {
  data() {
    return {
      editForm: {},
      visible: true,
      loading: false,
      title: "修改账号信息",
      rules:{
        email:{ required: true, message: '请输入账号', trigger: 'blur' },
        password:{required:true,message:"请输入密码"},
        role:{required:true,message:"请选择角色"}
      },
      roleList:[
        {
          label:"超级管理员",
          value:"0"
        },
        {
          label:"数据看板",
          value:"1"
        },
      ]
    };
  },
  props: ["rowData", "showView"],
  created() {
    if (this.rowData.email) {
      this.title =this.showView?"查看信息":"修改账号信息";
      this.editForm = {...this.rowData};
    } else {
      this.title = "新增账号";
       this.editForm={}
    }
  },
  methods: {
    changeRole(e){
      console.log(e)
      this.editForm['role']=e
    },
    closeDialog() {
      this.$emit("close");
    },
    getList(){
      let that=this
      getProcessList().then(res=>{
        let list=res.processList
        list.map((item,index)=>{
          let obj={}
          obj['label']=item['name']
          obj["value"]=item['id']
          that.roleList.push(obj)
        })
      }).catch(e=>{

      })
    },
    submitForm() {
       this.$refs.editForm.validate((res)=>{
        if(res){
           this.$emit("save", this.editForm);
        }
      })

      
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/userManage/pop/addPop.vue